// i18n area 'storage' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.nl-NL.meta.json.
import type { enUS } from './storage'

export const nlNL: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Storage aanmaken',
      path: 'Pad',
      pathHint: 'Absoluut pad onder een toegestane root (standaard /var/lib/tvirt/pools/)',
      shared: 'Gedeelde storage',
      sharedChip: 'gedeeld',
      sharedVerifiedChip: 'gedeeld · geverifieerd',
      sharedVerifiedTooltip: 'Deling geverifieerd: de kruislingse sondes bevestigen dat elk lid de gegevens ziet die de andere leden schrijven.',
      sharedDisputedChip: 'gedeeld · NIET geverifieerd',
      sharedDisputedTooltip: 'Deling NIET geverifieerd',
      sharedDisputedPair: '{observer} ziet de gegevens niet die {writer} schrijft',
      sharedHint: 'Netwerkshare die op elk lid lokaal op hetzelfde pad is gemount — voorwaarde voor live migration (declaratief).',
      sharedDanger: 'GEVAAR — TVirt GELOOFT deze vlag: zet je hem aan, dan gaat elk lid ervan uit dat het op dit pad DEZELFDE bytes ziet. Op een map die NIET echt een gedeelde share is (NFS/CIFS/clusterbestandssysteem) is het resultaat corruptie en gegevensverlies bij de eerste migratie of de eerste HA-herstart op een andere node. Zet hem alleen aan als het pad een share is die op elke node identiek is gemount.',
      type: 'Type',
      capacity: 'Capaciteit',
      provisioned: 'Toegewezen',
      provisionedOvercommit: 'Potentiële verplichting boven de capaciteit: thin volumes kunnen groeien tot {n} GiB.',
      phase: { ready: 'Gereed', degraded: 'Gedegradeerd', error: 'Fout' },

      // Ronde #156 (standaarddialoog): de VOLLEDIGE detaildialoog — tabbladen,
      // de configuratieregels per driver en het waargenomen oppervlak.
      tabConfig: 'Configuratie',
      tabCapacity: 'Capaciteit en status',
      cardIdentity: 'Identiteit',
      cardPlacement: 'Plaatsing',
      cardConnection: 'Verbinding',
      usedReal: 'Werkelijk gebruik',
      capacityUnknown: 'De node heeft de capaciteit van deze pool nog niet gerapporteerd — hier worden geen getallen verzonnen',
      overcommitHint: 'Verplichting boven de capaciteit: legitiem op thin pools, houd het werkelijke gebruik in de gaten',
      supportedContent: 'Ondersteunde inhoud',
      content: {
        disks: 'Schijven',
        catalogFiles: 'Catalogusbestanden',
        backups: 'Backups',
        appVolumes: 'App-volumes'
      },
      defaultDiskFormat: 'Standaard schijfformaat',
      reserveGiB: 'Gereserveerde vrije ruimte (GiB)',
      available: 'Beschikbaar',
      diskCount: 'Schijven',
      filesystem: 'Bestandssysteem',
      observedAt: 'Waargenomen op',
      lostAtRow: 'Verloren verklaard op',
      sharedProbeRow: 'Verificatie van de deling',
      sharedProbeNodes: 'Gesondeerde nodes',
      reachableFrom: 'Gedeclareerde bereikbaarheid',
      reachableFromHint: "De nodes van waaruit deze storage bereikbaar moet zijn. Een VM met schijven, ISO's of metadata hierop start niet en migreert niet op een node buiten deze lijst. Alle leden zijn voorgeselecteerd: beperk de lijst naar wens. Een node die later tot het cluster toetreedt, blijft erbuiten tot je hem hier toevoegt.",
      reachableFromNone: 'niet gedeclareerd',
      reachableFromTags: 'Bereikbaarheid per tag',
      reachableFromTagsHint: "Selector tag=waarde (items gescheiden door komma's, in AND): elk lid dat deze tags draagt wordt bereikbaar verklaard — dynamisch: een node taggen laat hem toetreden.",
      reachableFromTagsInvalid: "Ongeldig formaat — gebruik tag=waarde, gescheiden door komma's",
      reachableResolved: 'Opgeloste nodes: {nodes}',
      reachableDeclaredNotSeen: 'gedeclareerd maar niet gezien door de delingssonde op: {nodes}',
      reachableSeenNotDeclared: 'gezien maar niet gedeclareerd (buiten de perimeter) op: {nodes}',
      cephCluster: 'Beheerd Ceph-cluster',
      appGuardTitle: 'Storage in gebruik door de Apps',
      appEphemeralGuard: 'deze storage is de vluchtige clusterpool van de Apps — wijzig hem eerst via de pagina Apps en verwijder hem daarna.',
      appInUseGuard: 'hier leven roots en volumes van apps: {apps} — verplaats of verwijder ze eerst.',
      releaseRequiredTitle: "'{name}' verwijderen en de images ervan vrijgeven?",
      releaseRequiredBatchTitle: 'De geselecteerde storages verwijderen en hun images vrijgeven?',
      releaseRequiredBody: 'Het vrijgeven van de images verwijdert GEEN enkele byte: het afmelden laat de namespace op schijf staan, de images zijn eenvoudigweg niet meer gematerialiseerd en elke referentie van de scopes overleeft als claim — registreer de pool opnieuw en ze worden weer geadopteerd.',
      releaseConfirm: 'Verwijderen en de images vrijgeven'
    },
    lost: {
      chip: 'Verloren',
      action: 'Verloren verklaren',
      confirmTitle: 'De storage verloren verklaren',
      confirmBody: 'Verklaring van de operator op eigen, uitdrukkelijk risico: elke task die op deze storage of op zijn objecten in de wachtrij staat of loopt ZAL MISLUKKEN, verwijderingen worden alleen administratief (geen werk op het bestandssysteem) en nieuw fysiek werk wordt geweigerd. De bytes worden nooit aangeraakt — komt het volume weer tot leven, registreer het dan opnieuw en voer een scan uit om alles opnieuw te adopteren.',
      confirmSubmit: 'Verloren verklaren',
      error: 'De verklaring is geweigerd'
    },
    findings: {
      action: 'Gevonden objecten',
      title: 'Gevonden objecten',
      empty: 'Geen enkel object gevonden in de namespace van de storage',
      loadError: 'Kan de gevonden objecten niet laden',
      actionError: 'De beslissing is geweigerd',
      colKind: 'Type',
      colObject: 'Object',
      colConflict: 'Conflict',
      namespaceNotice:
        'Deze map was al geïnitialiseerd door een andere storage: het identiteitszegel is overschreven met dat van deze storage. De inhoud is NIET aangeraakt — bekijk de hieronder gevonden objecten, importeer wat je nodig hebt en sluit daarna deze melding.',
      kind: {
        disk: 'Schijf',
        catalogFile: 'Catalogusbestand',
        vmMetadata: 'VM-metadata',
        namespace: 'Namespace',
        foreign: 'Vreemd',
        volumeGroup: 'Volume group'
      },
      vgAdopt: {
        action: 'Volume group adopteren',
        title: 'Volume group adopteren',
        intro:
          'Dit apparaat draagt al een volume group met een TVirt-naam, maar het zegel noemt geen enkele hier geregistreerde storage. Het kan zijn wat een eerdere storage van DIT cluster op de LUN heeft achtergelaten — of wat EEN ANDER TVirt-cluster heeft achtergelaten op een LUN die van eigenaar is gewisseld: van hieruit zien beide gevallen er identiek uit, en daarom beslist niemand voor u.',
        irreversible: 'Kijk naar het apparaat, het zegel en de naam voordat u doorgaat: de adoptie kan niet ongedaan worden gemaakt.',
        device: 'Apparaat',
        seal: 'Zegel',
        sealNone: 'geen (geen tvirt.storageId-tag)',
        renameTo: 'Wordt hernoemd naar',
        renameNone: 'Geen hernoeming: de naam is al degene die deze storage afleidt',
        volumesNote:
          'De volumes die erin zitten worden NIET geadopteerd door dit gebaar: de volgende scan biedt ze een voor een aan, als gewone gevonden objecten.'
      },
      conflictChip: 'ID bestaat al',
      dismissedChip: 'Genegeerd',
      adopt: 'Adopteren',
      adoptFileTitle: 'Importeren in een catalogus',
      adoptFileHint: 'Bestanden bestaan alleen binnen de catalogi: kies de doelcatalogus voor het gevonden bestand.',
      purge: 'Van schijf verwijderen',
      dismiss: 'Negeren',
      purgeConfirmTitle: 'Van schijf verwijderen',
      purgeConfirmBody: 'De gevonden bytes van {id} worden van de storage verwijderd. Deze bewerking is onomkeerbaar.',
      taskStarted: 'Gestart — gaat verder als task op de achtergrond',
      scan: 'De storage scannen',
      scanStarted: 'Scan gestart…',
      scanDone: 'Scan afgerond — de gevonden objecten zijn bijgewerkt'
    },
    reinit: {
      action: 'Initialisatie opnieuw proberen'
    },
    wizard: {
      addButton: 'Toevoegen',
      title: 'Storage toevoegen',
      back: 'Terug',
      continue: 'Doorgaan',
      selectHint: 'Selecteer een protocol om te zien hoe TVirt het gebruikt.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Geëxporteerd pad',
      share: 'Share',
      username: 'Gebruikersnaam',
      password: 'Wachtwoord',
      passwordHint: 'Alleen schrijven: gebruikt voor de mount, daarna nooit meer getoond.',
      credential: 'Credential',
      credentialManual: 'Handmatig invoeren',
      credentialHint: 'Een keystore-item van het type gebruikersnaam en wachtwoord — het alternatief voor ze hier te typen.',
      credentialEmpty: 'Geen enkele credential van het type gebruikersnaam en wachtwoord in de keystore — maak er een aan in Systeem → Credentials, of typ het account hieronder.',
      options: 'Mountopties',
      optionsHint: "Gescheiden door komma's, ongewijzigd doorgegeven aan mount -o.",
      portal: 'Portal',
      portalHint: 'host[:poort] — de standaardpoort is 3260.',
      target: 'Target-IQN',
      targetHint: 'De naam van het iSCSI-target, begint met iqn.',
      lun: 'LUN',
      wholeLunRow: 'Op de schijven: deze storage noemt alleen het target',
      wholeLunHint: 'Deze storage noemt alleen het target: zijn LUN\'s worden één voor één schijven (Schijf aanmaken → hele LUN overnemen), op het target wordt niets geschreven.',
      lunHint: 'Nummer van de LUN op het target — 0 bij twijfel.',
      chapCredential: 'Credential (CHAP)',
      chapCredentialHint: 'Een keystore-item van het type CHAP (iSCSI) dat voor de login wordt gebruikt — het geheim reist nooit mee met de storage.',
      chapNone: 'Geen authenticatie',
      chapEmpty: 'Geen enkele credential van het type CHAP (iSCSI) in de keystore — maak er een aan in Systeem → Credentials. Zonder blijft de login niet-geauthenticeerd.',
      address: 'Adres',
      addressHint: 'Host of IP van het NVMe/TCP-target (traddr).',
      port: 'Poort',
      portHint: 'TCP-poort van het target — 4420 als je hem leeg laat.',
      targetNqn: 'Target-NQN',
      targetNqnHint: 'De NQN van het subsystem op het target, begint met nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace-ID binnen het subsystem — 1 bij twijfel.',
      dhchapCredential: 'Credential (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Een keystore-item van het type DH-HMAC-CHAP (NVMe) dat bij het verbinden wordt gebruikt — het geheim reist nooit mee met de storage.',
      dhchapNone: 'Geen authenticatie',
      dhchapEmpty: 'Geen enkele credential van het type DH-HMAC-CHAP (NVMe) in de keystore — maak er een aan in Systeem → Credentials. Zonder blijft de verbinding niet-geauthenticeerd.',
      monitors: 'Monitors',
      monitorsHint: "Endpoints van de Ceph-monitors, host[:poort], gescheiden door komma's of regeleinden — standaardpoort 6789.",
      pool: 'Pool',
      poolHint: 'De RBD-pool die je gebruikt — één RBD-image per schijf.',
      fs: 'Bestandssysteem',
      fsHint: 'De naam van het CephFS-bestandssysteem (mds_namespace bij de mount).',
      fsPath: 'Pad binnen het bestandssysteem',
      fsPathHint: 'Absoluut pad binnen het bestandssysteem dat de storage mount — / bij twijfel.',
      cephxCredential: 'Credential (cephx)',
      cephxCredentialHint: 'Een keystore-item van het type cephx: gebruikersnaam = naam van de client (client.…), secret = de base64-sleutel. Verplicht.',
      cephxNone: 'Geen enkele cephx-credential in de keystore — maak er een aan (type: cephx) in Systeem → Credentials, of laat een beheerd Ceph-cluster er een slaan met "Voorstellen als storage".',
      sharedByNature: 'Netwerkstorage is van nature gedeeld: elk lid mount hem op hetzelfde door TVirt beheerde pad.',
      error: 'De storage is geweigerd',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Overig',
        legacy: 'Legacy'
      },
      legacyHint: 'Volwaardig ondersteund — we zouden ze alleen niet kiezen voor een nieuwe installatie.',
      proto: {
        // De regel `usage` (Luca 2026-07-24) zegt hoe TVirt het protocol
        // gebruikt — in de eerste plaats welke inhoud is toegestaan: dir/nfs/
        // cifs herbergen schijven ÉN ISO-/schijf-images en templates, de
        // blokdrivers (iscsi/nvme-tcp/rbd) ALLEEN schijven.
        dir: {
          name: 'Lokale map',
          desc: 'Een directory op de node: eenvoudig en snel. Hij is LOKAAL aan één node, tenzij het pad een echt gedeelde share is — hem als gedeeld markeren terwijl hij dat niet is, kost gegevens.',
          usage: "TVirt bewaart er schijven van VM's, ISO-/schijf-images en templates."
        },
        nfs: {
          name: 'NFS',
          desc: 'Een NFS-export die het cluster mount — van nature gedeeld.',
          usage: "Herbergt schijven van VM's, ISO-/schijf-images en templates."
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Een Windows/Samba-share die het cluster mount — van nature gedeeld.',
          usage: "Herbergt schijven van VM's, ISO-/schijf-images en templates."
        },
        sftp: {
          name: 'SFTP',
          desc: 'Een extern bestandssysteem via SSH — zonder dat er een NAS-export nodig is.',
          usage: 'Op de roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: "Blok-LUN's via IP met gedeelde LVM erbovenop.",
          usage: 'Alleen schijven — één thin volume per schijf; herbergt geen ISO-images en geen templates.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block devices verdeeld over een Ceph-cluster.',
          usage: 'Alleen schijven — één RBD-image per schijf, native geopend door QEMU; herbergt geen ISO-images.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Het gedistribueerde bestandssysteem van Ceph, door de kernel op het cluster gemount — shared by nature.',
          usage: 'Herbergt VM-schijven, ISO-/schijf-images en templates — de dir-familie op een Ceph-bestandssysteem (cephx-credential verplicht).'
        },
        fc: { name: 'SCSI/FC', desc: "SCSI-LUN's op een FibreChannel-fabric — de klassieke FC-SAN." },
        fcoe: { name: 'SCSI/FCoE', desc: 'Hetzelfde SCSI op FibreChannel, met de FC-frames ingekapseld in Ethernet.' },

        // Levend sinds ronde #132 — de sleutel is de drivernaam uit het
        // contract, zodat de chip in de storagelijst hetzelfde item vindt.
        'iscsi-lun': {
          name: 'iSCSI (hele LUN\'s)',
          desc: 'Het iSCSI-target als drager van hele LUN\'s: elke schijf IS een LUN, rauw aan de gast doorgegeven — geen LVM ertussen.',
          usage: 'Alleen schijven — één hele LUN per schijf, overgenomen zoals ze is; het SAN-thuis van gedeeld-schrijvende schijven.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (hele namespaces)',
          desc: 'Het NVMe-subsysteem als drager van hele namespaces: elke schijf IS een namespace, rauw aan de gast doorgegeven.',
          usage: 'Alleen schijven — één hele namespace per schijf, overgenomen zoals hij is; gedeeld schrijven ja, SCSI persistent reservations nee.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'NVMe op afstand — geen SCSI in het pad — over gewoon TCP, met gedeelde LVM erbovenop.',
          usage: 'Alleen schijven — één thin volume per schijf; herbergt geen ISO-images en geen templates.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'NVMe op afstand over een FibreChannel-fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe op de FibreChannel-fabric die FCoE binnen Ethernet transporteert — de lagen FCoE en NVMe/FC op elkaar gestapeld.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI met het datapad verplaatst naar RDMA — elke fabric (InfiniBand, iWARP, RoCE). Voorbijgestreefd door NVMe/RDMA, nog aanwezig in arrays en in ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Native SCSI over RDMA, het tijdperk vóór iSER: InfiniBand (met fabric-discovery) en RoCE — overleeft in gedateerde HPC-storage.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'NVMe op afstand over elke RDMA-fabric — InfiniBand, iWARP, RoCE v1 en v2: één enkele configuratie, de node zegt welke hij heeft.' },
        s3: { name: 'S3', desc: 'S3-compatibele object storage — images en back-ups.' }
      }
    },
    catalogs: {
      title: 'Catalogi',
      createTitle: 'Catalogus aanmaken',
      editTitle: 'Catalogus bewerken',
      docTitle: 'Catalogus',
      notFound: 'Deze catalogus bestaat niet (meer?)',
      scopeHint: 'Wie deze scope leest, ziet elk bestand van de catalogus — en mag het gebruiken',
      files: 'Bestanden',
      noFiles: 'Geen bestanden',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT-tpl',
        vmTemplate: 'VM-tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // De systeemcatalogus (ronde #126): het huis van de ingebouwde objecten
      // van het platform — leesbaar voor iedereen, beschrijfbaar voor niemand.
      systemChip: 'systeem',
      systemTooltip: 'Systeemcatalogus: herbergt de ingebouwde objecten van het platform en is niet te wijzigen'
    },

    // Catalogusbestanden (ronde K1, inventory v2e/v2g): de catalogus is het
    // huis van de bestandsartefacten van het cluster — één lijst, titels per
    // kind.
    catalogFiles: {
      catalog: 'Catalogus',
      kindLabel: 'Type',
      physicalSize: 'Fysieke grootte',
      virtualSize: 'Virtuele grootte',

      // Ronde K3 (#64) + K4 (#65, ova/ovf met de boot-survival-mapping):
      // materialiseert een vm-template-bestand als VM Template in de inventaris.
      importTemplateAction: 'Importeren als VM Template',
      importTemplateLegacy: 'Geen formaat gedeclareerd — bruikbaar als seed voor schijven, niet importeerbaar',
      importTemplateTitle: 'Importeren als VM Template',
      importTemplateSubmit: 'Importeren',
      importTemplateError: 'Import mislukt',
      importTemplateHint: "Het .tvtpl-pakket wordt een VM Template: de bevroren hardware van het manifest plus één schijf per entry van het archief, elk geverifieerd tegen zijn checksum. NIC's en cd-/dvd-media horen niet bij een archief — voeg ze na de import toe.",
      importTemplateQcow2Hint: 'Een kale qcow2 wordt een template met ÉÉN schijf en de gedeclareerde standaardhardware: profiel linux, UEFI, 2 vCPU, 2048 MiB, opstarten vanaf zijn enige schijf. Corrigeer dat bij de deploy.',
      importTemplateName: 'Naam van het template',
      importTemplateNameHint: 'Leeg = {name} (-import-<n> als die bezet is)',
      importTemplateStorage: 'Storage voor de schijven',
      importTemplateMetadataStorage: 'Storage voor de metadata',
      importTemplateMetadataHint: 'Een blokstorage herbergt de VM-metadata niet (firmware, varstore) — kies er een van het type dir/nfs/cifs.',
      importTemplateStarted: 'Import gestart — het template verschijnt op het tabblad Templates zodra de task sluit.',

      // Sprekende labels in het enkelvoud (#86): findings en inventarisatie
      // zeggen WAT het bestand is — het generieke 'Catalogusbestand' blijft
      // alleen als terugval.
      kind: {
        iso: 'ISO-image',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-template',
        'oci-image': 'OCI-image',
        'firmware-ovmf': 'OVMF-firmware'
      },
      title: {
        iso: 'ISO-images',
        'ct-rootfs': 'CT-templates',
        'vm-template': 'VM-templates',
        'oci-image': 'OCI-images',
        'firmware-ovmf': 'OVMF-firmware'
      },
      createTitle: {
        iso: 'ISO-image toevoegen',
        'ct-rootfs': 'CT-template registreren',
        'vm-template': 'VM-template toevoegen',
        'oci-image': 'OCI-image toevoegen',
        'firmware-ovmf': 'OVMF-firmware toevoegen'
      },
      formatHint: 'Afgeleid uit de extensie van het gekozen bestand — corrigeer het als het verkeerd heeft geraden',
      tarballHint: 'Een rootfs-tarball in het standaard LXC-formaat (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, of een gewone .tar)',
      ociArchiveHint: 'Een docker-archive- of oci-archive-tarball (.tar of .tar.gz), bijvoorbeeld uit docker save',
      uploadResumeHint: 'Upload onderbroken — het bestand wacht op upload: stuur hetzelfde bestand opnieuw om te hervatten',
      moveTitle: 'Bestand verplaatsen',
      moveHint: 'Twee onafhankelijke dimensies: Catalogus verplaatst de koppeling (zelfde id, geen byte beweegt, de scope wordt die van de doelcatalogus); Storage verplaatst de gegevens — elke gekoppelde kopie volgt, geweigerd zolang het bestand in gebruik is. Samen gekozen: eerst de catalogus, dan de storage.',
      moveCatalog: 'Doelcatalogus',
      moveCatalogHint: 'Alleen de koppeling verhuist: een VM die het bestand gekoppeld heeft, moet de doelcatalogus kunnen zien',
      keepCurrent: 'Niet wijzigen',
      rehomed: 'Koppeling verplaatst naar de gekozen catalogus',
      copyAction: 'Kopiëren naar catalogus…',
      copyTitle: 'Kopiëren naar catalogus',
      copyLinkHint: 'De kopie is een nieuwe koppeling naar dezelfde gegevens — er wordt niets gedupliceerd op de storage.',
      copyCatalog: 'Doelcatalogus',
      copyCatalogHint: 'De kopie is de manier waarop een bestand tussen catalogi reist',
      sameCatalog: 'Dezelfde als de bron',
      sharedObjectHint: 'De gegevens van dit bestand worden gedeeld door {count} gekoppelde kopieën',
      deleteLastLink: 'Dit is de LAATSTE koppeling naar deze inhoud: ook de gegevens op de storage worden verwijderd.',
      deleteLinkOnly: 'Alleen deze koppeling wordt verwijderd — de gegevens blijven en zijn nog bereikbaar via de andere gekoppelde kopieën ({count}).',
      noCatalog: 'Er is geen enkele catalogus — maak er een aan',
      inlineCatalogName: 'Naam van de catalogus',

      // In het platform ingebouwde bestanden (ronde #126): storage null — ze
      // worden gelezen en gekloond, nooit verplaatst, verwijderd of hernoemd.
      embeddedChip: 'ingebouwd',
      embeddedStorage: 'Ingebouwd in het platform',
      embeddedNoMove: 'Ingebouwd bestand van het platform: het leeft op geen enkele storage — kloon het in plaats daarvan',
      embeddedCopyHint: 'De kloon materialiseert de ingebouwde bytes op een echte storage: kies de doelstorage en de doelcatalogus — de kopie is een gewoon bestand',
      sourceEmbedded: 'Ingebouwd in het platform',
      nodesRow: 'Aanwezigheid per node',
      nodesSummary: '{present} van {total} nodes hebben het',
      nodePresent: 'aanwezig',
      nodeMissing: 'ontbreekt',
      nodeUnknown: 'nog niet gemeld',
      nodesHint: 'Het asset staat op de schijf van elke node (pakket trantor-tvirt-assets): een node zonder dit asset kan geen VM met deze firmware definiëren en de Guest Tools niet aanbieden. Verschillende versies tussen nodes zijn normaal tijdens een rolling update.',

      // Download (ronde #108): de bytes reizen met hun eigen, aparte recht.
      downloadAction: 'Downloaden',
      downloadNotReady: 'De inhoud is nog niet gereed — downloaden vereist een bestand dat ready is',
      downloadDenied: 'Jouw rol bevat catalog.download niet — de bytes downloaden is een ander recht dan het bestand gebruiken',

      // Ronde #156 (standaarddialoog): de ontbrekende leesregels van de
      // detaildialoog — de feiten van het gedeelde object, de gedeclareerde
      // checksum, de gebruikers.
      objectRow: 'Storage-object',
      objectLinksRow: 'Gekoppelde kopieën',
      declaredChecksum: 'Gedeclareerde SHA-256',
      usedByRow: 'Gebruikt door',
      usedByVms: 'VM',
      usedByDisks: 'Schijven',
      transferRow: 'Overdracht',
      storageLockHint: 'Verandert alleen via de actie Verplaatsen'
    },

    // De inventarisatie per storage (ronde K1, inventory v2b #2): alleen
    // lezen, elk object beheer je vanuit zijn eigen sectie.
    objects: {
      action: 'Inhoud verkennen',
      title: 'Inhoud van de storage',
      hint: 'Alleen-lezen inventarisatie van wat er op deze storage leeft — elk object beheer je vanuit zijn eigen sectie.',
      empty: 'Geen enkel object geregistreerd op deze storage',
      loadError: 'Kan de inhoud niet laden',
      colDetail: 'Detail',
      manage: 'Beheren in zijn eigen sectie',
      kind: {
        disk: 'Schijf',
        catalogFile: 'Catalogusbestand',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-metadata',
        appRoot: 'App-root',
        appVolume: 'App-volume'
      }
    },
    inventory: {
      tabCatalogs: 'Catalogi',
      storage: 'Storage',
      sizeGib: 'Grootte (GiB)',
      format: 'Formaat',
      size: 'Grootte',
      sourceType: 'Bron',
      sourceFile: 'Bestand uploaden',
      sourceUrl: 'Downloaden van URL',
      file: 'Bestand',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Verplicht: de download wordt geverifieerd tegen deze SHA-256',
      verifyChecksum: 'Checksum verifiëren',
      checksumOffHint: 'De download wordt zonder verificatie aanvaard — de berekende SHA-256 wordt hoe dan ook vastgelegd',
      uploading: 'Uploaden…',
      move: {
        action: 'Verplaatsen',
        diskTitle: 'Schijf verplaatsen',
        target: 'Doelstorage',
        diskHint: 'De schijf behoudt zijn identiteit: de bytes reizen naar de gekozen storage. Een VM die hem gebruikt moet uit staan; zijn er snapshots, dan weigert een iSCSI-kant de verplaatsing.',
        noTargets: 'Geen compatibele doelstorage',
        submit: 'Verplaatsen',
        error: 'De verplaatsing is geweigerd'
      },
      clone: {
        action: 'Klonen',
        title: 'Schijf klonen',
        name: 'Naam van de kopie',
        storage: 'Doelstorage',
        sameStorage: 'Dezelfde als de bron',
        linked: 'Linked clone',
        linkedHint: 'Onmiddellijke qcow2-overlay geketend aan de bronschijf (alleen qcow2-bronnen). De default is een volledige kopie.',
        linkedCrossHint: 'Een linked clone blijft op de storage van de bron: kies "Dezelfde als de bron" om hem in te schakelen.',
        submit: 'Klonen',
        error: 'Het klonen is geweigerd'
      },
      copy: {
        action: 'Kopiëren',
        name: 'Naam van de kopie',
        storage: 'Doelstorage',
        sameStorage: 'Dezelfde als de bron',
        submit: 'Kopiëren',
        error: 'De kopie is geweigerd'
      },
      taskStarted: 'Gestart — gaat verder als task op de achtergrond',
      cephObjects: 'Naar de objectdetails op Ceph',
      phase: {
        ready: 'Gereed',
        creating: 'Wordt aangemaakt',
        'awaiting-upload': 'Wacht op upload',
        downloading: 'Wordt gedownload',
        verifying: 'Wordt geverifieerd',
        deleting: 'Wordt verwijderd',
        error: 'Fout',
        'in-use': 'In gebruik'
      }
    }
  }
}
